import simpleRestProvider from 'ra-data-simple-rest';
import { fetchUtils } from 'react-admin';

const apiUrl = 'https://ckwin44.com/api';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function ensureTrailingSlash(url) {
  const [path, query] = url.split('?');
  const fixedPath = path.endsWith('/') ? path : `${path}/`;
  return query ? `${fixedPath}?${query}` : fixedPath;
}

const httpClient = (url, options = {}) => {
  url = ensureTrailingSlash(url);
  options.credentials = 'include';
  options.headers = new Headers(options.headers || { Accept: 'application/json' });
  if (options.method && options.method !== 'GET') {
    options.headers.set('X-CSRFToken', getCookie('csrftoken'));
  }
  return fetchUtils.fetchJson(url, options);
};

const baseDataProvider = simpleRestProvider(apiUrl, httpClient);

const hasFile = (data) =>
  Object.keys(data).some((key) => {
    const value = data[key];
    return value && typeof value === 'object' && value.rawFile instanceof File;
  });

const createFormData = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    const value = data[key];

    if (value && typeof value === 'object' && value.rawFile instanceof File) {
      formData.append(key, value.rawFile);
    } else if (value instanceof File) {
      formData.append(key, value);
    } else if (value === null || value === undefined) {
      return;
    } else if (typeof value === 'boolean') {
      formData.append(key, value ? 'true' : 'false');
    } else if (typeof value === 'object') {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });
  return formData;
};

export const dataProvider = {
  ...baseDataProvider,

  create: (resource, params) => {
    if (hasFile(params.data)) {
      const formData = createFormData(params.data);
      return httpClient(`${apiUrl}/${resource}/`, {
        method: 'POST',
        body: formData,
      }).then(({ json }) => ({ data: json }));
    }
    return baseDataProvider.create(resource, params);
  },

  // ---------- UPDATE: PUT এর বদলে PATCH — শুধু ফর্মে থাকা ফিল্ডগুলোই আপডেট হবে,
  // ফর্মে নেই এমন ফিল্ড (যেমন user) অপরিবর্তিত থাকবে ----------
  update: (resource, params) => {
    if (hasFile(params.data)) {
      const formData = createFormData(params.data);
      return httpClient(`${apiUrl}/${resource}/${params.id}/`, {
        method: 'PATCH',
        body: formData,
      }).then(({ json }) => ({ data: json }));
    }
    return httpClient(`${apiUrl}/${resource}/${params.id}/`, {
      method: 'PATCH',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  blockUser: (userId, reason) =>
    httpClient(`${apiUrl}/users/${userId}/block/`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    }).then(({ json }) => json),

  unblockUser: (userId) =>
    httpClient(`${apiUrl}/users/${userId}/unblock/`, {
      method: 'POST',
      body: JSON.stringify({}),
    }).then(({ json }) => json),

  addUserNote: (userId, note) =>
    httpClient(`${apiUrl}/users/${userId}/add_note/`, {
      method: 'POST',
      body: JSON.stringify({ note }),
    }).then(({ json }) => json),

  // === নতুন: উইথড্র লিমিট এডিট করার জন্য — UserShow পেজের "Withdrawal Limit"
  // এডিট বাটন থেকে কল হবে, backend-এর UserViewSet.set_withdraw_limit action-এ যায় ===
  setWithdrawLimit: (userId, newLimit) =>
    httpClient(`${apiUrl}/users/${userId}/set_withdraw_limit/`, {
      method: 'POST',
      body: JSON.stringify({ withdraw_limit_total: newLimit }),
    }).then(({ json }) => json),

  getUserSummary: (userId) =>
    httpClient(`${apiUrl}/users/${userId}/summary/`, { method: 'GET' }).then(({ json }) => json),
};